/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type WorkatoIntegration = "HiBob" | "%future added value";
export type ActivateWorkatoIntegrationInput = {|
  integration?: ?WorkatoIntegration,
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type activateWorkatoIntegrationMutationVariables = {|
  input: ActivateWorkatoIntegrationInput
|};
export type activateWorkatoIntegrationMutationResponse = {|
  +activateWorkatoIntegration: ?{|
    +outcome: ?string,
    +company: ?{|
      +id: string,
      +workatoCustomerId: ?string,
      +workatoIframeToken: ?string,
      +hiBobEnabled: ?boolean,
      +workatoForecastHiBobConnectionId: ?string,
      +workatoHiBobConnectionId: ?string,
      +sageIntacctEnabled: ?boolean,
      +workatoForecastSageIntacctConnectionId: ?string,
      +workatoSageIntacctConnectionId: ?string,
    |},
  |}
|};
export type activateWorkatoIntegrationMutation = {|
  variables: activateWorkatoIntegrationMutationVariables,
  response: activateWorkatoIntegrationMutationResponse,
|};
*/


/*
mutation activateWorkatoIntegrationMutation(
  $input: ActivateWorkatoIntegrationInput!
) {
  activateWorkatoIntegration(input: $input) {
    outcome
    company {
      id
      workatoCustomerId
      workatoIframeToken
      hiBobEnabled
      workatoForecastHiBobConnectionId
      workatoHiBobConnectionId
      sageIntacctEnabled
      workatoForecastSageIntacctConnectionId
      workatoSageIntacctConnectionId
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "ActivateWorkatoIntegrationInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ActivateWorkatoIntegrationPayload",
    "kind": "LinkedField",
    "name": "activateWorkatoIntegration",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "outcome",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Company",
        "kind": "LinkedField",
        "name": "company",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "workatoCustomerId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "workatoIframeToken",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hiBobEnabled",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "workatoForecastHiBobConnectionId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "workatoHiBobConnectionId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sageIntacctEnabled",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "workatoForecastSageIntacctConnectionId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "workatoSageIntacctConnectionId",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "activateWorkatoIntegrationMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "activateWorkatoIntegrationMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "activateWorkatoIntegrationMutation",
    "operationKind": "mutation",
    "text": "mutation activateWorkatoIntegrationMutation(\n  $input: ActivateWorkatoIntegrationInput!\n) {\n  activateWorkatoIntegration(input: $input) {\n    outcome\n    company {\n      id\n      workatoCustomerId\n      workatoIframeToken\n      hiBobEnabled\n      workatoForecastHiBobConnectionId\n      workatoHiBobConnectionId\n      sageIntacctEnabled\n      workatoForecastSageIntacctConnectionId\n      workatoSageIntacctConnectionId\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'b12a1eef38706fbde344df9984986c35';

module.exports = node;
